import { getEnvironmentVariable } from "../../../global/environmentVariables";

export const loadStripeAsync = async () => {
  try {
    const { loadStripe } = await import("@stripe/stripe-js");
    return await loadStripe(getEnvironmentVariable("STRIPE_PK"));
  } catch (error) {
    // Now reload page if stripe doesn't successfully load
    const retryData = sessionStorage.getItem("stripe_retry_data");
    const now = Date.now();

    if (retryData) {
      const { timestamp, attempts } = JSON.parse(retryData);
      const oneMinuteAgo = now - 60 * 1000;

      if (timestamp > oneMinuteAgo && attempts >= 1) {
        console.warn(
          "Stripe.js failed to load after retry, not refreshing again"
        );
        return null;
      }
    }
    sessionStorage.setItem(
      "stripe_retry_data",
      JSON.stringify({
        timestamp: now,
        attempts: 1
      })
    );

    window.location.reload();
    return null;
  }
};
